import { AbstractControl, FormArray, ValidatorFn } from "@angular/forms";

export function validateNamesInFormArray(): ValidatorFn {
  return (control: AbstractControl) => {
    if (!(control instanceof FormArray)) {
      return { invalidFormArray: true }; // Nicht vom Typ FormArray
    }
    const invalidEntries = control.value.filter((item: any) => 
        !item || 
        typeof item.firstname !== 'string' || item.firstname.trim() === '' || 
        typeof item.surname !== 'string' || item.surname.trim() === ''
    );

    return invalidEntries.length > 0 ? { nonEmptyStrings: true } : null;
  };
}